import { SELECT_ALL_SCENARIO_GROUP_INFO } from "../../../constants/closeLoop/scenarioGroup/closeLoopScenarioGroupConstants";

export const selectAllScenarioGroupInfo = (info) => {
    return {
        type: SELECT_ALL_SCENARIO_GROUP_INFO,
        totalGroup: info.number_of_groups,
        totalGroupList: info.scenario_group_list,
    };
};
